import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Legal = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-black text-white">
        {/* Hero Section */}
        <div className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-AfacadFluxLight font-bold text-white mb-8">
              Legal Notice
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Important legal information regarding the use of our website and services.
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div className="pt-4 pb-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-12">
              {/* Section 1: Disclaimer */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  1. Disclaimer
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>The website and its content are provided "as is," without warranties of any kind, express or implied.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>Venturecorp does not guarantee uninterrupted access or error-free operation.</span>
                  </li>
                </ul>
              </div>

              {/* Section 2: Limitation of Liability */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  2. Limitation of Liability
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>Venturecorp shall not be liable for any damage, direct or indirect, arising from use of this website.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>This includes, but is not limited to, loss of data, business interruption, or financial loss.</span>
                  </li>
                </ul>
              </div>

              {/* Section 3: Intellectual Property Rights */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  3. Intellectual Property Rights
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>All intellectual property rights (logos, trademarks, content) are owned by Venturecorp or licensed to us.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>Unauthorized use is strictly prohibited and may result in legal action.</span>
                  </li>
                </ul>
              </div>

              {/* Section 4: Governing Law */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  4. Governing Law
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>This Legal Notice is governed by the laws of Sri Lanka.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>Any disputes shall be subject to the exclusive jurisdiction of the courts of Sri Lanka.</span>
                  </li>
                </ul>
              </div>

              {/* Contact Information */}
              <div className="bg-gradient-to-r from-purple-600/20 to-indigo-600/20 rounded-lg p-8 border border-purple-500/30">
                <h3 className="text-xl font-AfacadFluxLight font-bold text-white mb-4">
                  Contact Information
                </h3>
                <p className="text-gray-300">
                  For any legal inquiries or questions regarding this notice, please contact us at{' '}
                  <a href="mailto:email@venturecorplk.com" className="text-purple-400 hover:text-purple-300 transition-colors">
                    email@venturecorplk.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Legal;
